// extracted by mini-css-extract-plugin
export default {"gridheight":"DocumentRegister_gridheight__EDwLi","section-title":"DocumentRegister_section-title__P0fMH","notes-text":"DocumentRegister_notes-text__p2Waq"};